import { render, staticRenderFns } from "./DeleteMetadataDialog.vue?vue&type=template&id=2280938c&"
import script from "./DeleteMetadataDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteMetadataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports